export default "__VITE_ASSET__DqFboX1U__"